module.exports = __webpack_public_path__ + "img/colory-facebook.595ea84d.svg";